import React from 'react';
import LoansList from '../office/LoansList';

const StoreKeeperLoansList: React.FC = () => {
  return <LoansList />;
};

export default StoreKeeperLoansList; 